import { styled } from "@mui/material/styles";
import React from "react";

import {
  FormControlLabel,
  Radio,
} from "@mui/material";
import { useRadioGroup } from "@mui/material/RadioGroup";
import "./index.scss";
import { fontConfig } from "theme/fontConfig";

const StyledFormControlLabel = styled((props) => (
  <FormControlLabel {...props} />
))(({ theme, checked }) => ({
  ".MuiFormControlLabel-label": checked && {
    color: theme.palette.primary.main,
  },
  ".MuiFormControlLabel-label": {
    fontFamily: fontConfig.EasyCareStyledFormControlLabelFont.family
  },
}));

function MyFormControlLabel(props) {

  return <StyledFormControlLabel checked={props.checked} {...props} />;
}
function TriggerCommon({
  options,
  onChange,
  selectedValue,
}) {
  return (
    <div className="trigger-icons">
      {options?.map(({ icon, label, value, className }) => (
        <div className={`trigger-single-icon ${className} ${selectedValue === value ? "checked" : ""}`} key={value} onClick={() => onChange(value)}>
          <MyFormControlLabel
            checked={selectedValue === value}
            control={<Radio />}
            className="radio-trigger"
          />
          <div className="trigger-content">
            {icon}
            <span>{label}</span>
          </div>
        </div>
      ))}
    </div>

  );
}

export default TriggerCommon;
